// Global Instructions Rule Applied!
//
// Aggregation dimension catalog for the standalone Investments screen. It is
// the per-fund Fund Investment Detail catalog plus a "Fund" dimension at the
// top (the per-fund tab is scoped to a single fund, so it has no Fund dim;
// this multi-fund screen does). 'fund' is a native at__get_measures dim.

import {
  FUND_INVESTMENT_AGGREGATION_DIMENSIONS,
  type AggregationDimensionOption
} from '../../funds/components/aggregations/aggregationDimensions.ts'

export const INVESTMENT_AGGREGATION_DIMENSIONS: AggregationDimensionOption[] = [
  { value: 'fund', label: 'Fund', native: true },
  ...FUND_INVESTMENT_AGGREGATION_DIMENSIONS
]

/** Default: per Fund, then per Company. */
export const INVESTMENT_DETAIL_DEFAULT_AGGREGATION: string[] = ['fund', 'company']
